import { type AircraftData } from '#entities';
import { EAircraftEventType, EAircraftStatus, ESeverity } from '#shared';

import { getAircraftTimeSeverity } from './getAircraftTimeSeverity';

export const getAircraftStatus = (aircraftData: AircraftData) => {
  const actualEvent = aircraftData.aircraftEvents[0];
  const timeSeverity = getAircraftTimeSeverity(aircraftData);
  let status = EAircraftStatus.NotAvailable;
  if (actualEvent?.type === EAircraftEventType.Trip) {
    status = EAircraftStatus.OnTrip;
  } else if (actualEvent?.type === EAircraftEventType.Maintenance) {
    status = EAircraftStatus.Maintenance;
  } else if (timeSeverity !== ESeverity.NA) {
    status = EAircraftStatus.Available;
  }
  return status;
};
